import React from 'react';
import styles from './index.module.css';
import i18nEnglish from "../../i18n/en";
import i18nSwiss from "../../i18n/de-ch";
import i18nFrench from "../../i18n/fr";
import i18nItalian from "../../i18n/it";
import { supportedLanguages } from "../../config/config";

const BottomBar = () => {
  const currentYear = new Date().getFullYear(); // Get the current year dynamically
  
  // Selecting the appropriate language data for the banner text
  const i18nMap = {
        'de': i18nSwiss,
        'de-ch': i18nSwiss,
        'de-CH': i18nSwiss,
        'gsw': i18nSwiss,
        'en': i18nEnglish,
        'fr': i18nFrench,
        'it': i18nItalian,
  }[document.documentElement.getAttribute('data-language') || supportedLanguages[0]] || i18nEnglish;
  return (
    <div className={`${styles.bottombar} bottombar`}>
      <p className="consultant-hint">{i18nMap.consultantHint}</p>
      <p className="imprint">
        <span className="imprint-line">
          © Copyright {currentYear} <a tabIndex={-1} href="https://elektrobedarf.ch" target="_blank">Elektrobedarf Troller AG</a>
        </span> 
        <span className="imprint-divider"> | </span> 
        <span className="imprint-line">
        {i18nMap.publisher}
        </span>  
        <span className="imprint-divider"> | </span>
        <span className="imprint-line">
        {i18nMap.development} <a tabIndex={-1} href="https://t2consult.de" target="_blank">t2consult</a> - {i18nMap.t2consultAddress}
        </span>
      </p>  
    </div>
  );
};

export default BottomBar;
